import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const ProjectsPage = lazy(() =>
  import('./pages/ProjectsPage').then(m => ({ default: m.ProjectsPage }))
);
const ProjectDetailPage = lazy(() =>
  import('./pages/ProjectDetailPage').then(m => ({ default: m.ProjectDetailPage }))
);

/**
 * Project routes, gated exactly like the API (backend ADR-017): admins,
 * teachers and pupils share both screens — the server decides what each of them
 * sees — while parents get 403 on the whole surface, so the guard denies them
 * up front.
 */
export const projectRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher', 'pupil']} />}>
    <Route path="/projects" element={<ProjectsPage />} />
    <Route path="/projects/:publicId" element={<ProjectDetailPage />} />
  </Route>
);
